module.exports = __webpack_public_path__ + "static/media/icon-confuso.7a66b978.svg";